import { gql } from 'apollo-angular';
import { userWithMinimalSecondFactorFragment } from './shared-user.fragments';

export const WatchUserWithSecondFactorQuery = gql`
  query WatchUserWithSecondFactorQuery($id: ID!) {
    node(id: $id) {
      ... on User {
        ...UserWithMinimalSecondFactor
      }
    }
  }
  ${userWithMinimalSecondFactorFragment}
`;
